import styled from 'styled-components';

export const SkuSearchContainer = styled.div`
  padding: 16px;
  margin: 0 -16px;
  border-radius: 8px;
  background: var(--blue-1);
`;
